module.exports = __webpack_public_path__ + "static/media/4.04475630.jpg";